/** English (`en`) catalog; keys are ASCII per localization standard. */
export const catalogEn: Record<string, string> = {
  "quiz.account.menu_aria_label": "Account and sign out",
  "quiz.account.pending_summary": "Account",
  "quiz.home.checking_session": "Checking whether you are signed in…",
  "quiz.home.cta_continue_my_quizzes": "Continue to My quizzes",
  "quiz.home.cta_create_quiz_primary": "Create a quiz",
  "quiz.home.cta_sign_in_organizer": "Sign In",
  "quiz.home.footer_aux_aria_label": "Legal and support links",
  "quiz.home.footer_legal": "© {year} Quiz. All rights reserved.",
  "quiz.home.footer_link_contact": "Contact us",
  "quiz.home.footer_link_help": "Help center",
  "quiz.home.footer_link_privacy": "Privacy policy",
  "quiz.home.footer_link_terms": "Terms of service",
  "quiz.home.header_sign_in": "Sign in",
  "quiz.home.header_title": "Quiz",
  "quiz.home.hero_signed_in_generic": "Welcome back",
  "quiz.home.hero_signed_in_named": "Hello, {name}",
  "quiz.home.hero_signed_in_subtitle":
    "Create and manage quizzes for your training sessions.",
  "quiz.home.hero_subtitle":
    "Invite participants by email. They learn and sit tests.",
  "quiz.home.hero_title": "Training quizzes built from your documents",
  "quiz.home.label_display_name": "Display name",
  "quiz.home.label_user_id": "User ID",
  "quiz.home.link_view_existing_quizzes": "Browse existing quizzes",
  "quiz.home.link_my_quizzes": "My quizzes",
  "quiz.home.link_new_training_quiz":
    "Start training quiz wizard (recommended path)",
  "quiz.home.logout": "Sign out",
  "quiz.home.logout_failed": "Sign out failed. Try again.",
  "quiz.home.logout_pending": "Signing out…",
  "quiz.home.participant_guidance_body":
    "Participants will be e-mailed a link to the quiz.",
  "quiz.home.participant_guidance_summary": "How participants join",
  "quiz.home.role_organizers_bullet_1": "Upload training material.",
  "quiz.home.role_organizers_bullet_2":
    "Generate the quiz pool and send invitations.",
  "quiz.home.role_organizers_title": "Organizers",
  "quiz.home.role_participants_bullet_1": "Use the link in email.",
  "quiz.home.role_participants_bullet_2": "Complete quiz.",
  "quiz.home.role_participants_title": "Participants",
  "quiz.home.session_error": "Could not read sign-in status from the server.",
  "quiz.home.signed_in_title": "Account",
  "quiz.home.skip_to_main": "Skip to main content",
  "quiz.my_quizzes.title": "My quizzes",
  "quiz.my_quizzes.loading": "Loading quizzes…",
  "quiz.my_quizzes.empty":
    "No drafts yet. Create one to add training material. The quiz name can default to your first uploaded file; you can edit it here anytime before publish.",
  "quiz.my_quizzes.feature_off":
    "Training quizzes are not enabled on this deployment.",
  "quiz.my_quizzes.sign_in_required": "Sign in to manage quizzes.",
  "quiz.my_quizzes.load_failed": "Could not load quizzes.",
  "quiz.my_quizzes.create_submit": "Create quiz",
  "quiz.my_quizzes.create_failed": "Could not create draft. Try again.",
  "quiz.my_quizzes.quiz_title_field": "Quiz title",
  "quiz.my_quizzes.save_title": "Save title",
  "quiz.my_quizzes.untitled_placeholder":
    "Untitled — set from first file or enter a name",
  "quiz.my_quizzes.title_save_failed": "Could not save title. Try again.",
  "quiz.my_quizzes.quiz_status_draft": "Draft",
  "quiz.my_quizzes.quiz_status_published": "Published",
  "quiz.my_quizzes.quiz_status_other": "{status}",
  "quiz.my_quizzes.summary_with_pipeline": "{lifecycle} · {pipeline}",
  "quiz.my_quizzes.generation_phase_running": "Generating questions",
  "quiz.my_quizzes.generation_phase_failed": "Generation failed",
  "quiz.my_quizzes.generation_phase_queued": "Generation queued",
  "quiz.my_quizzes.generation_phase_other": "{phase}",
  "quiz.my_quizzes.created_line": "Created {date}",
  "quiz.my_quizzes.loading_more": "Loading more…",
  "quiz.detail.back_my_quizzes": "Back to My quizzes",
  "quiz.detail.loading": "Loading quiz…",
  "quiz.detail.sign_in_required": "Sign in to view this quiz.",
  "quiz.detail.not_found": "Quiz not found or you do not have access.",
  "quiz.detail.load_failed": "Could not load quiz data. Try again.",
  "quiz.detail.recipients_failed": "Could not load recipient list. Try again.",
  "quiz.detail.created_line": "Created {date}",
  "quiz.detail.quiz_id_line": "Quiz ID: {quiz_id}",
  "quiz.detail.status_line": "Quiz status: {status}",
  "quiz.detail.title_edit_aria": "Edit quiz title",
  "quiz.detail.title_edit_glyph": "\u270E",
  "quiz.detail.title_confirm_aria": "Save title",
  "quiz.detail.title_confirm_glyph": "\u2713",
  "quiz.detail.title_cancel_aria": "Cancel editing title",
  "quiz.detail.title_cancel_glyph": "\u2715",
  "quiz.detail.open_wizard_add_recipients":
    "Open setup wizard to add recipients or send invitations",
  "quiz.detail.pool_heading": "Question pool",
  "quiz.detail.pool_summary":
    "Active: {active}. Total stored: {total}. Inactive (not drawn): {inactive}.",
  "quiz.detail.pool_empty": "No active questions in the pool.",
  "quiz.detail.roster_heading": "Test candidates",
  "quiz.detail.roster_empty": "No assignments yet.",
  "quiz.detail.roster_empty_hint_wizard": "Open the wizard to invite people.",
  "quiz.detail.col_email": "Email",
  "quiz.detail.col_invitation": "Invitation",
  "quiz.detail.col_attempt": "Attempt",
  "quiz.detail.col_completed": "Completed",
  "quiz.detail.col_invite": "Invite link",
  "quiz.detail.completed_dash": "-",
  "quiz.detail.invitation_sent": "Sent",
  "quiz.detail.invitation_not_sent": "Not sent",
  "quiz.detail.attempt_pass": "Passed",
  "quiz.detail.attempt_fail": "Failed",
  "quiz.detail.attempt_in_progress": "In progress",
  "quiz.detail.attempt_not_submitted": "Not started",
  "quiz.detail.transcript_open_aria":
    "Open submitted test transcript for {email}",
  "quiz.detail.transcript_title": "Test transcript",
  "quiz.detail.transcript_close": "Close",
  "quiz.detail.transcript_fullscreen": "Full page",
  "quiz.detail.transcript_fullscreen_aria":
    "Open this transcript on a full page",
  "quiz.detail.transcript_back_to_quiz": "Back to quiz",
  "quiz.detail.transcript_loading": "Loading transcript…",
  "quiz.detail.transcript_error": "Could not load transcript.",
  "quiz.detail.transcript_meta_line": "{email} · {date}",
  "quiz.detail.transcript_attempt_id": "Attempt ID: {id}",
  "quiz.detail.transcript_outcome_passed": "Outcome: Passed",
  "quiz.detail.transcript_outcome_failed": "Outcome: Failed",
  "quiz.detail.transcript_score": "Score: {percent}%",
  "quiz.detail.transcript_selected_option": "Their answer: {text}",
  "quiz.detail.transcript_correct_option": "Correct answer: {text}",
  "quiz.detail.transcript_no_selection": "(No answer recorded)",
  "quiz.detail.transcript_mark_correct": "Marked correct",
  "quiz.detail.transcript_mark_incorrect": "Marked incorrect",
  "quiz.detail.transcript_signing_area_aria":
    "Signing area (reserved for handwritten signatures when printed)",
  "quiz.detail.get_invite_link": "Get invite link",
  "quiz.detail.invite_link_confirm":
    "Create a new invite link for this person? Any earlier invite link for this assignment stops working.",
  "quiz.detail.invite_link_copied": "Invite link copied to the clipboard.",
  "quiz.detail.invite_link_manual_copy": "Copy this invite link:",
  "quiz.detail.invite_link_failed": "Could not get the invite link. Try again.",
  "quiz.detail.invite_link_no_origin":
    "This deployment cannot build invite links (missing public site URL). Ask your operator to set QUIZ_INVITE_PUBLIC_ORIGIN.",
  "quiz.detail.choice_correct": "Correct: {text}",
  "quiz.wizard.page_title": "Training quiz setup",
  "quiz.wizard.back_my_quizzes": "My quizzes list",
  "quiz.wizard.progress": "Step {step} of {total}",
  "quiz.wizard.intro_lead":
    "We will guide you through the organizer flow: confirm the quiz name, skim the upcoming uploads and automation steps you will unlock next, paste recipient emails, and send invitations.",
  "quiz.wizard.create_draft_button": "Create draft and begin",
  "quiz.wizard.create_failed": "Could not create the draft quiz. Try again.",
  "quiz.wizard.loading_quiz": "Loading quiz...",
  "quiz.wizard.quiz_missing": "Could not load this quiz.",
  "quiz.wizard.need_sign_in": "Sign in again from the home page.",
  "quiz.wizard.preview_note":
    "Generation, pool review, and full publish checks still evolve alongside the APIs. Recipient mail delivers through SES once operators set QUIZ_SES_MAIL_FROM. Training uploads require the backend material bucket (operator stack).",
  "quiz.wizard.step_title_name": "Name your quiz",
  "quiz.wizard.step_title_help":
    "Titles can default later from uploaded files; polish it now so guests recognize the quiz in invitations.",
  "quiz.wizard.save_title_continue": "Save title and continue",
  "quiz.wizard.step_training_heading": "Training material",
  "quiz.wizard.step_training_body":
    "Upload up to three .txt (UTF-8 plain text), .pdf, or .xlsx files. Wait until every file shows Ready, then press Continue. Scanned PDFs without embedded text may extract little or no text.",
  "quiz.wizard.step_generation_heading":
    "Generation settings and question pool",
  "quiz.wizard.step_generation_body":
    "Set how many questions each participant sees and the answer shape, then generate draft multiple-choice items from your ready training files. Curate the pool below until you have enough active questions, then continue.",
  "quiz.wizard.generation_pipeline_status": "Generation pipeline: {status}",
  "quiz.wizard.generation_settings_heading": "Quiz generation settings",
  "quiz.wizard.generation_settings_hint":
    "Defaults suit most quizzes; adjust only when you need a different length or shape.",
  "quiz.wizard.generation_questions_per_attempt_label": "Questions per quiz",
  "quiz.wizard.generation_pool_count_label": "Question pool size",
  "quiz.wizard.generation_pool_count_hint":
    "Defaults to twice the number of questions in each quiz; each user will be asked a random sample.",
  "quiz.wizard.generation_shape_heading": "Question shape",
  "quiz.wizard.generation_option_count_label": "Answers per question",
  "quiz.wizard.generation_min_correct_label": "Minimum correct answers",
  "quiz.wizard.generation_max_correct_label": "Maximum correct answers",
  "quiz.wizard.generation_shape_invalid":
    "Fix the question shape: require 1 <= minimum correct answers <= maximum correct answers <= answers per question.",
  "quiz.wizard.generation_single_correct_note":
    "When minimum and maximum correct answers are both 1, each generated question has a single fully correct choice.",
  "quiz.wizard.generation_config_label":
    "Optional generation settings (JSON object, merged into quiz configuration)",
  "quiz.wizard.generation_config_placeholder": "{}",
  "quiz.wizard.generation_queue_button":
    "Generate questions from training extracts",
  "quiz.wizard.generation_busy": "Submitting…",
  "quiz.wizard.generation_json_invalid":
    "Settings must be valid JSON object syntax.",
  "quiz.wizard.generation_failed": "Could not queue generation. Try again.",
  "quiz.wizard.generation_material_not_ready":
    "All training files must be Ready before generation.",
  "quiz.wizard.generation_locked": "This quiz is locked after publish.",
  "quiz.wizard.generation_queued":
    "Generation accepted. Adjust the refreshed pool below, then continue.",
  "quiz.wizard.generation_completed_failed":
    "The server marked this generation attempt as failed (see operator logs when available). Adjust settings above or retry after fixing extracts.",
  "quiz.wizard.generation_done_reload":
    "Generation finished; review the refreshed pool.",
  "quiz.wizard.generation_failed_banner":
    "Last generation failed. Fix training extracts or adjust generation settings, then retry.",
  "quiz.wizard.generation_running_notice":
    "Question generation reads your READY extracts — expect a brief wait while the backend runs.",
  "quiz.wizard.generation_reset_hint":
    "After about the Lambda time limit plus a short buffer (often a few minutes), you can reset if the UI still shows running. Do not reset while you believe generation is actively progressing.",
  "quiz.wizard.generation_reset_stuck_button": "Reset stuck generation",
  "quiz.wizard.generation_reset_busy": "Resetting generation state…",
  "quiz.wizard.generation_reset_failed":
    "Could not reset generation state. Try again.",
  "quiz.wizard.generation_reset_too_soon":
    "Generation may still be running on the server. Wait a few minutes, then try reset again or refresh after the pipeline times out.",
  "quiz.wizard.pool_readonly_while_running":
    "Pool editing is paused while generation is running.",
  "quiz.wizard.pool_edit": "Edit",
  "quiz.wizard.pool_save_edit": "Save changes",
  "quiz.wizard.pool_cancel_edit": "Cancel",
  "quiz.wizard.generation_in_progress_blocked":
    "Generation is already in progress for this quiz.",
  "quiz.wizard.generation_continue_blocked":
    "Queue generation before continuing.",
  "quiz.wizard.generation_continue_blocked_pool":
    "Add enough active questions so the pool size meets questions_per_attempt before continuing.",
  "quiz.wizard.pool_section_title": "Draft question pool",
  "quiz.wizard.pool_section_help":
    "Each item needs exactly {n, plural, one {# answer option} other {# answer options}} (from option_count in configuration, default four).",
  "quiz.wizard.pool_empty": "No draft questions yet. Add at least one below.",
  "quiz.wizard.pool_stem_placeholder": "Question text shown to participants",
  "quiz.wizard.pool_choice_label": "Option {n}",
  "quiz.wizard.pool_correct_label":
    "Correct option (1-based position in the list above)",
  "quiz.wizard.pool_correct_multi_hint":
    "Mark every choice that should count as correct (within the minimum and maximum you set in generation settings).",
  "quiz.wizard.pool_choices_aria": "Answer options",
  "quiz.wizard.pool_correct_option_mark": "Correct",
  "quiz.wizard.pool_item_meta":
    "{count, plural, one {# option} other {# options}}; correct position {pos}",
  "quiz.wizard.pool_inactive_marker": "(inactive)",
  "quiz.wizard.pool_delete": "Remove",
  "quiz.wizard.pool_add_aria": "Add question",
  "quiz.wizard.pool_add_button": "Add question",
  "quiz.wizard.pool_busy": "Saving pool…",
  "quiz.wizard.pool_failed": "Pool update failed. Check fields and try again.",
  "quiz.wizard.pool_validation":
    "Fill the stem and every option before adding.",
  "quiz.wizard.pool_publish_hint":
    "Active questions: {active}. You need at least {needed} active questions for this quiz configuration before invitations.",
  "quiz.wizard.publish_pool_too_small":
    "The active question pool is smaller than questions_per_attempt. Return to step 3 and add questions.",
  "quiz.wizard.step_invite_heading": "Recipients and invitations",
  "quiz.wizard.step_invite_body":
    "Paste one participant email address per line. We deduplicate addresses and enforce the server-side limit.",
  "quiz.wizard.recipients_label": "Recipient emails",
  "quiz.wizard.recipients_placeholder":
    "person1@organization.org\nperson2@organization.org",
  "quiz.wizard.recipients_hint":
    "Blank lines ignored; duplicates removed; maximum 20 accepted addresses.",
  "quiz.wizard.publish_button": "Publish and send invitations",
  "quiz.wizard.publish_failed": "Publishing failed. Check addresses and retry.",
  "quiz.wizard.publish_conflict": "This quiz already published invitations.",
  "quiz.wizard.publish_validation":
    "One or more email addresses looked invalid after trimming duplicates.",
  "quiz.wizard.back_step": "Back",
  "quiz.wizard.continue": "Continue",
  "quiz.wizard.success_title": "Invitations recorded",
  "quiz.wizard.success_lead_publish":
    "We saved each assignment and queued mail per deployment settings below.",
  "quiz.wizard.success_lead_repeat":
    "This quiz shows {count, plural, one {# invitation saved} other {# invitations saved}}. Reopen wizard after publishing to revisit your checklist.",
  "quiz.wizard.mail_notice_ses_optional":
    "If operators set QUIZ_SES_MAIL_FROM (and SES identities are verified out of sandbox), SES sends HTTPS magic links.",
  "quiz.wizard.mail_notice_skipped":
    "SES outbound is skipped in this workspace; configure QUIZ_SES_MAIL_FROM plus IAM SES permissions when you want real delivery.",
  "quiz.wizard.mail_sent": "Email sent",
  "quiz.wizard.mail_failed": "Send failed",
  "quiz.wizard.mail_skipped": "Skipped (no SES)",
  "quiz.wizard.col_email": "Recipient",
  "quiz.wizard.col_delivery": "Mail status",
  "quiz.wizard.back_to_my_quizzes": "Back to My quizzes",
  "quiz.wizard.view_quiz_detail": "View quiz detail",
  "quiz.wizard.material_docs_heading": "Uploaded files",
  "quiz.wizard.material_empty":
    "No files yet — add at least one document below.",
  "quiz.wizard.material_upload_pick":
    "Choose a file (.txt, .pdf, .docx, .xlsx)",
  "quiz.wizard.material_choose_file": "Choose file",
  "quiz.wizard.material_drop_aria":
    "Add training documents by dropping files here or using the file chooser",
  "quiz.wizard.material_drop_hint":
    "Drop files here (.txt, .pdf, .docx, .xlsx) or",
  "quiz.wizard.material_busy": "Uploading…",
  "quiz.wizard.material_no_file": "Choose a file first.",
  "quiz.wizard.material_failed":
    "Upload could not finish. Try again or pick another file.",
  "quiz.wizard.material_put_failed":
    "Direct upload to storage failed. Try again.",
  "quiz.wizard.material_storage_off":
    "Training material storage is not configured on this deployment (operator: set QUIZ_MATERIAL_BUCKET on Lambda).",
  "quiz.wizard.material_limit":
    "Maximum number of training documents reached for this quiz.",
  "quiz.wizard.material_next_blocked":
    "Continue only after every uploaded file shows Ready (all extracts succeeded).",
  "quiz.wizard.material_delete_aria": "Remove file",
  "quiz.wizard.material_remove_failed": "Could not remove the file. Try again.",
  "quiz.wizard.material_state_AWAITING_BYTES": "Awaiting upload",
  "quiz.wizard.material_state_INGESTING": "Processing",
  "quiz.wizard.material_state_READY": "Ready",
  "quiz.wizard.material_state_FAILED": "Failed",
  "quiz.health.heading": "Backend health",
  "quiz.health.loading": "Calling GET /api/v1/health...",
  "quiz.health.httpStatus": "HTTP status: {status}",
  "quiz.health.responseBody": "Response body",
  "quiz.health.networkError": "Could not reach the API.",
  "quiz.health.notJson": "Response was not valid JSON.",
  "quiz.organizer.sign_in.title": "Sign In",
  "quiz.organizer.sign_in.lead": "Choose a provider to continue.",
  "quiz.organizer.sign_in.google": "Continue with Google",
  "quiz.organizer.sign_in.github": "Continue with GitHub",
  "quiz.organizer.sign_in.bootstrap.heading":
    "Operator credentials (environment)",
  "quiz.organizer.sign_in.bootstrap.lead":
    "For break-glass access when OAuth is unavailable.",
  "quiz.organizer.sign_in.bootstrap.username_label": "Username",
  "quiz.organizer.sign_in.bootstrap.password_label": "Password",
  "quiz.organizer.sign_in.bootstrap.submit": "Sign in",
  "quiz.organizer.sign_in.nav_home": "Home",
  "quiz.components.button.sample_label": "Continue",
  "quiz.components.button.danger_sample": "Remove",
  "quiz.components.icon_button.sample_aria": "More actions",
  "quiz.components.icon_button.sample_glyph": "+",
  "quiz.ui_demo.heading": "UI component library",
  "quiz.ui_demo.lead":
    "Static showcase for shared quiz-frontend controls used across routes.",
  "quiz.ui_demo.subheading_buttons": "Buttons",
  "quiz.ui_demo.caption_enabled": "Enabled primary",
  "quiz.ui_demo.caption_disabled": "Disabled primary",
  "quiz.ui_demo.caption_app_link": "Text link",
  "quiz.ui_demo.caption_btn_danger": "Danger button",
  "quiz.ui_demo.caption_btn_ghost": "Ghost button",
  "quiz.ui_demo.caption_btn_secondary": "Outline secondary button",
  "quiz.ui_demo.caption_icon_btn": "Icon button",
  "quiz.ui_demo.caption_layout_card": "Card surface",
  "quiz.ui_demo.caption_layout_headings": "Heading scale",
  "quiz.ui_demo.caption_layout_stack": "Vertical stack",
  "quiz.ui_demo.caption_layout_text": "Body and muted text",
  "quiz.ui_demo.sample_app_link_label": "Open health check page",
  "quiz.ui_demo.sample_card_body": "Card inner content example.",
  "quiz.ui_demo.sample_heading_h3": "Third-level heading",
  "quiz.ui_demo.sample_heading_h4": "Fourth-level heading",
  "quiz.ui_demo.sample_text_body": "Primary body copy for descriptions.",
  "quiz.ui_demo.sample_text_muted": "Supporting muted copy for hints.",
  "quiz.ui_demo.skip_to_main": "Skip to main content",
  "quiz.ui_demo.stack_line_one": "Stack row one",
  "quiz.ui_demo.stack_line_two": "Stack row two",
  "quiz.ui_demo.subheading_forms": "Forms",
  "quiz.ui_demo.subheading_layout": "Layout and typography",
  "quiz.ui_demo.caption_field_file": "File input with label",
  "quiz.ui_demo.caption_field_radio": "Radio group",
  "quiz.ui_demo.caption_field_select": "Select",
  "quiz.ui_demo.caption_field_text": "Text field with hint",
  "quiz.ui_demo.caption_field_text_invalid": "Text field with error",
  "quiz.ui_demo.caption_field_textarea": "Text area",
  "quiz.ui_demo.caption_checkbox": "Checkbox",
  "quiz.ui_demo.forms_error_required": "Name is required.",
  "quiz.ui_demo.forms_file_hint": "Accepts .txt for demo only.",
  "quiz.ui_demo.forms_hint_name": "Shown on official forms as display name.",
  "quiz.ui_demo.forms_label_agree": "I agree to the demo terms",
  "quiz.ui_demo.forms_label_bio": "Biography",
  "quiz.ui_demo.forms_label_locale": "Preview language",
  "quiz.ui_demo.forms_label_name": "Display name",
  "quiz.ui_demo.forms_label_upload": "Training file",
  "quiz.ui_demo.forms_placeholder_bio": "Short biography text",
  "quiz.ui_demo.forms_placeholder_name": "Ada Lovelace",
  "quiz.ui_demo.forms_radio_a": "Option A",
  "quiz.ui_demo.forms_radio_b": "Option B",
  "quiz.ui_demo.forms_radio_legend": "Pick one option",
  "quiz.ui_demo.forms_select_de": "German",
  "quiz.ui_demo.forms_select_en": "English",
  "quiz.ui_demo.alert_error_body":
    "Fix the highlighted fields before continuing.",
  "quiz.ui_demo.alert_error_title": "Save failed",
  "quiz.ui_demo.alert_info_body":
    "Background jobs may take a minute to finish.",
  "quiz.ui_demo.alert_info_title": "Heads up",
  "quiz.ui_demo.alert_success_body": "Your draft was stored successfully.",
  "quiz.ui_demo.alert_success_title": "Saved",
  "quiz.ui_demo.alert_warn_body":
    "Pool size is close to the minimum required to publish.",
  "quiz.ui_demo.alert_warn_title": "Check pool size",
  "quiz.ui_demo.locale_picker_label": "Interface language",
  "quiz.ui_demo.caption_alert_info": "Info alert",
  "quiz.ui_demo.caption_alert_success": "Success alert",
  "quiz.ui_demo.caption_alert_warning": "Warning alert",
  "quiz.ui_demo.caption_alert_error": "Error alert",
  "quiz.ui_demo.caption_badges": "Status badges",
  "quiz.ui_demo.caption_empty_demo": "Empty state",
  "quiz.ui_demo.caption_loading_row": "Loading row",
  "quiz.ui_demo.caption_progress_demo": "Progress line",
  "quiz.ui_demo.caption_table_demo": "Simple table",
  "quiz.ui_demo.display_badge_neutral": "Draft",
  "quiz.ui_demo.display_badge_success": "Ready",
  "quiz.ui_demo.display_badge_warning": "Queued",
  "quiz.ui_demo.display_empty_body": "Create a quiz to see drafts listed here.",
  "quiz.ui_demo.display_empty_title": "No quizzes yet",
  "quiz.ui_demo.display_progress_text": "Step 2 of 5 (demo).",
  "quiz.ui_demo.display_table_col_email": "Email",
  "quiz.ui_demo.display_table_col_state": "State",
  "quiz.ui_demo.display_table_row1_email": "a@example.com",
  "quiz.ui_demo.display_table_row1_state": "SENT",
  "quiz.ui_demo.display_table_row2_email": "b@example.com",
  "quiz.ui_demo.display_table_row2_state": "NOT_SENT",
  "quiz.ui_demo.loading_label": "Loading quizzes...",
  "quiz.ui_demo.subheading_display": "Data display",
  "quiz.ui_demo.subheading_feedback": "Alerts and loading",
  "quiz.ui_demo.subheading_domain": "Quiz-specific widgets",
  "quiz.ui_demo.subheading_overlays": "Overlays",
  "quiz.ui_demo.caption_mc_option": "Multiple-choice option tiles",
  "quiz.ui_demo.caption_pool_row": "Pool item row",
  "quiz.ui_demo.caption_reader": "Training reader shell",
  "quiz.ui_demo.caption_disclosure": "Disclosure block",
  "quiz.ui_demo.caption_modal": "Modal dialog",
  "quiz.ui_demo.domain_mc_opt_a": "Option A text",
  "quiz.ui_demo.domain_mc_opt_b": "Option B text",
  "quiz.ui_demo.domain_pool_meta": "4 choices · active",
  "quiz.ui_demo.domain_pool_stem":
    "What is the first step in the incident response checklist?",
  "quiz.ui_demo.domain_reader_sample":
    "Training excerpt: always verify identity before granting access. This paragraph demonstrates scrollable material inside the reader shell for participant review sessions.",
  "quiz.ui_demo.overlay_disclosure_body":
    "Extra policy text can stay collapsed until an organizer expands this block.",
  "quiz.ui_demo.overlay_disclosure_summary": "Show policy details",
  "quiz.ui_demo.overlay_modal_body":
    "This is a native dialog element for confirmations.",
  "quiz.ui_demo.overlay_modal_close": "Close",
  "quiz.ui_demo.overlay_modal_open": "Open sample modal",
  "quiz.ui_demo.overlay_modal_title": "Sample modal",
  "quiz.participant.answer_all": "Answer every question before submitting.",
  "quiz.participant.error_load":
    "The invitation may be invalid or expired. Use the link from your latest email or contact the organizer.",
  "quiz.participant.error_missing_token":
    "This page needs a complete invitation link including its token query.",
  "quiz.participant.error_title": "This link could not be opened",
  "quiz.participant.loading": "Loading your assignment…",
  "quiz.participant.name_back_material": "Back to training material",
  "quiz.participant.name_continue": "Continue",
  "quiz.participant.name_heading": "Your details",
  "quiz.participant.name_hint":
    "Shown on your results summary when the organizer configured reporting labels.",
  "quiz.participant.name_intro":
    "Enter the name you want the organizer to see with this quiz attempt.",
  "quiz.participant.name_label": "Your name",
  "quiz.participant.name_placeholder": "e.g. Jordan Smith",
  "quiz.participant.name_required": "Enter your name to continue.",
  "quiz.participant.nav_back": "Back",
  "quiz.participant.nav_next": "Next",
  "quiz.participant.abort_attempt": "Abandon attempt",
  "quiz.participant.abort_attempt_confirm":
    "Stop this attempt? Your progress will be discarded. If you already completed an attempt, you will see those results instead.",
  "quiz.participant.abort_attempt_aria":
    "Abandon this quiz attempt without submitting your answers",
  "quiz.participant.progress_label": "Question {current} of {total}",
  "quiz.participant.question_heading": "Questions",
  "quiz.participant.resume_attempt": "Resume quiz",
  "quiz.participant.result_failed": "Did not pass",
  "quiz.participant.result_passed": "Passed",
  "quiz.participant.result_ident_quiz_label": "Quiz",
  "quiz.participant.result_ident_participant_label": "Completed by",
  "quiz.participant.result_ident_participant_not_set": "Name not provided",
  "quiz.participant.result_training_heading":
    "Training materials for this quiz",
  "quiz.participant.result_transcript_heading": "How you answered",
  "quiz.participant.transcript_option_aria": "Your answer option {n}: {text}",
  "quiz.participant.transcript_question_correct": "Correct",
  "quiz.participant.transcript_question_wrong": "Wrong",
  "quiz.participant.result_transcript_selection_note":
    "Per-question results are unavailable in this session. Listed below are only the options you chose.",
  "quiz.participant.result_retry": "Try again",
  "quiz.participant.score_label": "Score: {percent}%",
  "quiz.participant.score_label_with_threshold":
    "Score: {percent}% — pass threshold {passPercent}%",
  "quiz.participant.skip_to_main": "Skip to main content",
  "quiz.participant.start_attempt": "Start quiz",
  "quiz.participant.submit_assignment_issued": "Invitation sent on {datetime}.",
  "quiz.participant.submit_answers": "Submit answers",
  "quiz.participant.submitting": "Submitting…",
  "quiz.participant.training_intro":
    "Open each listed file link to save a copy of the training document before starting.",
  "quiz.participant.training_resume_intro":
    "You already started this quiz. Review the training material again if helpful, then continue where you left off.",
  "quiz.participant.training_docs_empty":
    "There are no training documents for this quiz yet.",
  "quiz.participant.training_doc_download_aria":
    "Download training document {filename}",
  "quiz.participant.training_heading": "Training material",
};
